import * as React from 'react';
const SvgSignage = (props) => (
  <svg viewBox="0 0 124 113" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M71.678 81.355v21.29h5.806v7.742M56.193 81.355v21.29h-5.806v7.742M73.613 102.645h-5.806M122 2H2v69.677h120V2Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M34.903 36.839h52.258M70.728 20.407l16.433 16.432L70.728 53.27"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgSignage;
